import { TextButton } from '@creditornot/cb-button';
import { cbSemanticCssVars } from '@creditornot/cb-ingredients';
import { Tabs } from '@creditornot/cb-tabs';
import styled from 'styled-components';

import { Typography as T } from 'common/typography';

export const Header = styled(T.Heading4)`
  display: flex;
  flex-direction: column;
`;

export const Root = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
`;

export const HeaderContainer = styled.div`
  display: flex;
  padding: 44px 24px 16px;
  border-block-end: 1px solid ${cbSemanticCssVars.borderPrimary};
  align-items: flex-start;
  flex-direction: column;
  justify-content: flex-end;
  gap: 16px;
`;

export const StyledTextButton = styled(TextButton)`
  font-weight: bold;
  margin-block-end: 8px;
`;

export const StyledTabs = styled(Tabs)`
  width: 100%;
  margin: 0 0 24px;
  border-block-end: 1px solid ${cbSemanticCssVars.borderPrimary};
`;

export const Content = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 24px 70px;
  gap: 24px;
  flex-direction: column;
`;
